import { createResource } from '../core'
import { accountRelationshipsService } from './account-relationships.service'

/** TanStack Query for account links: `useAllAccountRelationships()`, `useCreateAccountRelationship()` and the rest. */
export const accountRelationships = createResource('account-relationships', accountRelationshipsService)

export const accountRelationshipsKeys = accountRelationships.keys
export const accountRelationshipsQueries = accountRelationships.queries
export const useAccountRelationships = accountRelationships.useList
export const useAllAccountRelationships = accountRelationships.useAll
export const useAccountRelationship = accountRelationships.useOne
export const useCreateAccountRelationship = accountRelationships.useCreate
export const useUpdateAccountRelationship = accountRelationships.useUpdate
export const useDeleteAccountRelationship = accountRelationships.useRemove
